import * as React from "react";

/**
 * Google's four-colour "G", as a recognisable source mark. NOT the wordmark,
 * which Google's brand rules keep for Google's own products; the "G" on its
 * own is what their sign-in and reviews guidance allow a third party to show.
 *
 * One copy, two call sites: the "Continue with Google" button and the Google
 * reviews badge on the Mum Hub landing page. The path data is Google's own,
 * unchanged, in Google's own four colours, which is the whole point of the
 * mark: a recoloured or redrawn G stops being recognisable as theirs.
 *
 * Decorative unless given a `label`: on the sign-in button the words beside
 * it say "Google" already, on the reviews badge the link's accessible name
 * does, so a second announcement would only repeat it.
 */
export function GoogleGlyph({
  className,
  label,
}: {
  className?: string;
  /** An accessible name, when the glyph carries meaning on its own. */
  label?: string;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : "true"}
      focusable="false"
    >
      <path
        fill="#4285F4"
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      />
      <path
        fill="#34A853"
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A10.99 10.99 0 0 0 12 23z"
      />
      <path
        fill="#FBBC05"
        d="M5.84 14.09a6.6 6.6 0 0 1 0-4.18V7.07H2.18a11 11 0 0 0 0 9.86l3.66-2.84z"
      />
      <path
        fill="#EA4335"
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"
      />
    </svg>
  );
}
